/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComputeOpportunityScoreResponse
 */
export interface ComputeOpportunityScoreResponse {
    /**
     * 
     * @type {number}
     * @memberof ComputeOpportunityScoreResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ComputeOpportunityScoreResponse
     */
    completed: number;
    /**
     * 
     * @type {number}
     * @memberof ComputeOpportunityScoreResponse
     */
    notFound: number;
    /**
     * 
     * @type {number}
     * @memberof ComputeOpportunityScoreResponse
     */
    error: number;
}

/**
 * Check if a given object implements the ComputeOpportunityScoreResponse interface.
 */
export function instanceOfComputeOpportunityScoreResponse(value: object): value is ComputeOpportunityScoreResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('completed' in value) || value['completed'] === undefined) return false;
    if (!('notFound' in value) || value['notFound'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ComputeOpportunityScoreResponseFromJSON(json: any): ComputeOpportunityScoreResponse {
    return ComputeOpportunityScoreResponseFromJSONTyped(json, false);
}

export function ComputeOpportunityScoreResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputeOpportunityScoreResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'completed': json['completed'],
        'notFound': json['notFound'],
        'error': json['error'],
    };
}

export function ComputeOpportunityScoreResponseToJSON(value?: ComputeOpportunityScoreResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'completed': value['completed'],
        'notFound': value['notFound'],
        'error': value['error'],
    };
}

